interface TravelAppWebInterfaceAndroid {
  sendTravelEvent: (data: string) => void;
}

interface TravelAppWebInterfaceIOS {
  postMessage: (data: string) => void;
}

declare global {
  interface Window {
    TravelAppWebInterface?: TravelAppWebInterfaceAndroid;
    webkit?: {
      messageHandlers: {
        TravelAppWebInterface?: TravelAppWebInterfaceIOS;
      };
    };
  }
}

export enum TravelAppInterfaceFunnelType {
  HOTELS = "hotels",
  PREMIUM_STAYS = "premiumStays",
}

export enum TravelAppInterfaceEventName {
  DATES_FINALIZED = "datesFinalized",
  DATES_RESET = "datesReset",
  DATE_PICKED = "datePicked",
  BOOKING_COMPLETE = "bookingComplete",
  SESSION_INITIALIZED = "sessionInitialized",
  SESSION_EXPIRING = "sessionExpiring",
  SESSION_EXPIRED = "sessionExpired",
  SESSION_FAILED = "sessionFailed",
}

interface BaseEvent<N> {
  name: N;
  funnel?: TravelAppInterfaceFunnelType;
  data?: unknown;
}

interface BaseEventWithData<N, D> extends BaseEvent<N> {
  data: D;
}

interface DatePickedEvent
  extends BaseEventWithData<
    TravelAppInterfaceEventName.DATE_PICKED,
    { startDate?: string; endDate?: string }
  > {}

interface DatesResetEvent
  extends BaseEvent<TravelAppInterfaceEventName.DATES_RESET> {}

interface DatesFinalizedEvent
  extends BaseEventWithData<
    TravelAppInterfaceEventName.DATES_FINALIZED,
    { fromDate: string; untilDate: string }
  > {}

interface BookingCompleteEvent
  extends BaseEvent<TravelAppInterfaceEventName.BOOKING_COMPLETE> {}

interface SessionInitializedEvent
  extends BaseEvent<TravelAppInterfaceEventName.SESSION_INITIALIZED> {}

interface SessionExpiringEvent
  extends BaseEvent<TravelAppInterfaceEventName.SESSION_EXPIRING> {}

interface SessionExpiredEvent
  extends BaseEvent<TravelAppInterfaceEventName.SESSION_EXPIRED> {}

interface SessionFailedEvent
  extends BaseEvent<TravelAppInterfaceEventName.SESSION_FAILED> {}

type TravelAppEvent =
  | DatePickedEvent
  | DatesResetEvent
  | DatesFinalizedEvent
  | BookingCompleteEvent
  | SessionInitializedEvent
  | SessionExpiringEvent
  | SessionExpiredEvent
  | SessionFailedEvent;

const getIsAndroid = () => !!window.TravelAppWebInterface;

const getIsIOS = () => !!window.webkit?.messageHandlers.TravelAppWebInterface;

const sendEvent = (event: TravelAppEvent) => {
  const eventToSend = JSON.stringify({
    eventName: event.name,
    funnelType: event.funnel,
    eventData: event.data,
  });

  if (getIsAndroid()) {
    window.TravelAppWebInterface?.sendTravelEvent(eventToSend);
  } else if (getIsIOS()) {
    window.webkit?.messageHandlers.TravelAppWebInterface?.postMessage(
      eventToSend
    );
  }
};

const travelAppInterface = { sendEvent };

export { travelAppInterface };
